const PrivacyZH = `
  <h1 class="static__title static__title--eula">个人信息的保护政策</h1>
  <h2 class="static__subtitle">2018年03月27日</h2>
  <ul class="contents">
    <li class="contents__item"><a class="link static__link" href="#1">一、总则</a></li>
    <li class="contents__item"><a class="link static__link" href="#2">二、个人信息处理规则与条件</a></li>
    <li class="contents__item"><a class="link static__link" href="#3">三、个人信息主体权利</a></li>
    <li class="contents__item"><a class="link static__link" href="#4">四、个人信息安全保障</a></li>
    <li class="contents__item"><a class="link static__link" href="#5">五、最后条款</a></li>
  </ul>
  <ol class="ordered-list">
    <li class="ordered-list__item" id="1">
      <span class="list-item-title">总则</span>
      <ol class="ordered-list">
        <p class="ordered-list__text">
          本《政策》规定了个人信息的处理规则和“Uchi.ru”有限公司（“Uchi.ru”有限公司纳税人识别码：7704821246，国家注册编码1127747152940,121069，地址：莫斯科市，斯托洛维街4号楼4座1号（以下简称“运营商”)）对个人信息的安全保障措施，旨在处理个人信息方面，对公民个人权利与自由进行保护，包括保护个人生活、个人隐私及家庭隐私权利不受侵犯。
        </p>
        <p class="ordered-list__text">本《政策》中的主要名词概念:</p>
        <li class="ordered-list__item ordered-list__item--embedded">
          个人信息&nbsp;&mdash; 直接或间接属于自然人（个人信息主体）的确定或者待定的任何相关信息;
        </li>
        <li class="ordered-list__item ordered-list__item--embedded">
          个人信息信息系统&nbsp;&mdash; 个人信息数据库中所包含的数据以及保障信息处理的信息技术和技术手段的总和;
        </li>
        <li class="ordered-list__item ordered-list__item--embedded">
          个人信息自动处理&nbsp;&mdash; 借助计算技术处理个人信息;
        </li>
        <li class="ordered-list__item ordered-list__item--embedded">
          冻结个人信息&nbsp;&mdash; 暂时停止个人信息处理（处理中需要确认个人信息的情况除外);
        </li>
        <li class="ordered-list__item ordered-list__item--embedded">
          个人信息加密&nbsp;&mdash; 加密操作必须通过辅助信息就来确定个人信息的主体归属；
        </li>
        <li class="ordered-list__item ordered-list__item--embedded">
          个人信息处理&nbsp;&mdash; 使用或不使用自动化工具对个人信息进行的任何行为（操作）或一切行为（操作）的总和，包括对个人信息的收集、录入、系统化、积累、存储、确认（更新、修改）、提取、使用、传输 （分发、提供、访问）、加密、锁定、删除、销毁等;
        </li>
        <li class="ordered-list__item ordered-list__item--embedded">
          运营商&nbsp;&mdash; 国家机关、市政机构、法人或自然人，独立或与他人组织和（或）实施个人信息处理，以及确定处理个人信息的目的，被处理的个人信息内容，处理个人信息的行为（操作);
        </li>
        <li class="ordered-list__item ordered-list__item--embedded">
          个人信息&nbsp;&mdash; 直接或间接属于确定或待定的自然人（个人信息主体）的任何相关信息;
        </li>
        <li class="ordered-list__item ordered-list__item--embedded">
          提供个人信息&nbsp;&mdash; 向特定人员或某个范围的人员披露个人信息的行为;
        </li>
        <li class="ordered-list__item ordered-list__item--embedded">
          传播个人信息 &nbsp;&mdash; 向不确定人群披露个人信息的行为（转让个人信息）或对个人数据获取人员无限制，包括在大众媒体上公布个人信息，或者通过其他方式提供个人数据的行为;
        </li>
        <li class="ordered-list__item ordered-list__item--embedded">
          个人信息的跨境转让&nbsp;&mdash; 向境外国家政权机关、外国自然人或者外国法人转让个人信息的行为;
        </li>
        <li class="ordered-list__item ordered-list__item--embedded">
          销毁个人信息&nbsp;&mdash; 导致不能恢复个人信息系统或者个人信息载体损坏的行为。
        </li>
        <p class="ordered-list__text">
          公司有义务公布或者通过其他方式查阅和处理该运营商《政策》不受限制。
        </p>
      </ol>
    </li>

    <li class="info-about-static__content-first-items" id="2">
      <span class="list-item-title">个人信息处理规则与条件</span>
      <ol class="info-about-static__content-number-ol">
        <li class="info-about-static__content-number-ol-items" id="2_1">
          <b>个人信息处理原则:</b>
          <p>运营商处理个人信息应遵循以下原则:</p>
          <ul class="info-about-static__content-number-ol">
            <li class="info-about-static__content-number-ol-items">在合法、公正的基础之上;</li>
            <li class="info-about-static__content-number-ol-items">在限定的范围处理个人信息以达到具体的、预定的、合法的目的;</li>
            <li class="info-about-static__content-number-ol-items">禁止违规处理人信息;</li>
            <li class="info-about-static__content-number-ol-items">禁止合并个人信息组建数据库以处理不兼容操作;</li>
            <li class="info-about-static__content-number-ol-items">只能进行符合处理目的的个人信息处理;</li>
            <li class="info-about-static__content-number-ol-items">对个人信息处理的内容和范围要符合所声明的处理目的;</li>
            <li class="info-about-static__content-number-ol-items">禁止对个人信息进行超出声明目的范围的处理;</li>
            <li class="info-about-static__content-number-ol-items">确保处理个人信息的准确性、充分性和现实性;</li>
            <li class="info-about-static__content-number-ol-items">如果运营商无法防止个人信息遭受侵犯，除非中国法律另有规定的，否则在实现其处理目的或无需实现这些目的的情况下，应该对个人信息进行销毁或加密。</li>
          </ul>
        </li>
        <li class="info-about-static__content-number-ol-items" id="2_2"><b>个人信息处理条件</b>
          <p>运营商在至少满足以下条件之一的情况下才允许对个人信息进行处理:</p>
          <ul>
            <li>对个人信息的处理需要经过个人信息主体同意;</li>
            <li>出于实现中国国际条约或法律所规定的目的，以及实现或履行中国立法赋予运营商的职能、权力和义务的必要;</li>
            <li>出于行政行为、司法行为，以及依据中国强制执行法履行职责的另一机构或职员的行为的必要;</li>
            <li>出于履行合同的必要，该合同一方或者合同受益人或担保人为个人信息主体，根据个人信息主体提议签订合同的必要或者个人信息主体将是受益人或担保人的合同签订的必要;</li>
            <li>出于实现运营商或第三方的权利及合法利益或者实现重要的社会目的的必要，前提条件在于该主体的权利和自由不受侵犯;</li>
            <li>不定范围人群访问个人信息应该经个人信息主体允许或在主体请求下（以下称公共个人信息);</li>
            <li>对公开或必须披露的个人信息进行处理时应该符合中国法律法规规定.</li>
          </ul>
        </li>
        <li class="info-about-static__content-number-ol-items" id="2_3">
          <b>个人信息的机密性</b>
          <p>除非中国法律另有规定，否则未经个人信息主体同意，运营商和其他有权访问个人信息的人员不得向第三方披露或传播个人信息。</p>
        </li>
        <li class="info-about-static__content-number-ol-items" id="2_4">
          <b>个人信息公共资源</b>
          <p>出于信息保护的目的，运营商可以创建个人信息主体的个人信息公共资源，包括目录和地址簿。在个人信息主体书面同意的个人信息公共资源中，可能包括其姓名、出生日期和地点、职务、联系电话、电子邮件地址以及个人信息主体提供的其他个人数据。</p>
          <p>根据个人信息主体、保护个人信息主体权利全权机构的要求或法院决定，有关个人信息主体的信息必须随时可以从个人信息公共资源中删除。</p>
        </li>
        <li class="info-about-static__content-number-ol-items" id="2_5">
          <b>个人信息的特殊范畴</b>
          <p>运营商处理涉及种族、国籍、政治观点、宗教或哲学信仰、健康状况、个人隐私等特殊范畴的个人信息时，应具备以下条件：</p>
          <ul>
            <li>个人信息主体书面同意处理自己的个人信息;</li>
            <li>个人信息由个人信息主体制作成公共信息;</li>
          </ul>
        </li>
        <li id="2_6">
          <b>个人生物学信息</b>
          <p>个人生物学信息是表现个人生理和生物学特征的信息，可以在此基础上确定其身份，只有在个人信息主体书面同意的情况下，运营商才有权能处理该类信息。</p>
        </li>
        <li id="2_7">
          <b>个人信息处理的委托</b>
          <p>运营商有权根据与个人信息主体达成的协议，在主体同意下，委托他人处理个人信息，中国法律法规另有规定的除外。代表运营商处理个人信息的委托人必须遵守中国法律法规的规定和本政策规定的处理个人信息的规则与条件。</p>
        </li>
        <li id="2_8">
          <b>中国公民个人信息的处理</b>
          <p>运营商有义务确保中国公民个人信息的记录、系统化、积累、存储、确认（更新、修改）、提取用于中国境内数据库，以下情况除外:</p>
          <ul>
            <li>出于实现中国国际条约或法律所规定的目的，以及实现或履行中国立法赋予运营商的职能、权力和义务的必要;</li>
            <li>出于行政行为、司法行为，以及依据中国强制执行法履行职责的另一机构或职员的行为的必要（以下简称司法行为）;</li>
            <li>出于记者职业工作和（或）大众媒体法定工作以及科教文卫等创作活动的需要，但不得违反个人信息主体的权利与合法利益。</li>
          </ul>
        </li>
        <li id="2_9">
          <b>个人信息的跨境传播</b>
          <p>运营商有义务确保在个人信息向境外传播之前对个人信息主体的权利进行相应的保护</p>
          <p>不能对个人信息主体提供相应的权利保护的，可以在以下情况下进行传播:</p>
          <ul>
            <li>个人信息主体书面同意跨境传输其个人信息;</li>
            <li>个人信息主体是合同执行方。</li>
          </ul>
        </li>
        <li id="2_10">
          <b>沟通用户</b>
          <p>运营商进行身份资料是为了向用户发送数学联欢节的进展情况（包括通过电话或发送SMS消息，以及通过电子邮件发送信息等）。</p>
        </li>
      </ol>
    </li>

    <li class="info-about-static__content-first-items" id="3">
      <span class="list-item-title">个人信息主体权利</span>
      <ol class="info-about-static__content-number-ol">
        <li class="info-about-static__content-number-ol-items" id="3_1">
          <b>个人信息主体同意处理其个人信息</b>
          <p>个人信息主体决定提供其个人信息并符合个人意愿和利益同意对其进行处理。个人信息主体或其代表可以以任意形式确认同意事实，除中国法律另有规定的除外。</p>
        </li>
        <li class="info-about-static__content-number-ol-items" id="3_2">
          <b>个人信息主体的权利</b>
          <p>个人信息主体有权从运营商处获取其个人信息处理的信息，受到中国法律法规限制的除外。如果个人信息不完整、已过期、不准确、涉嫌非法获取或者不符合声明处理目的，个人信息主体有权要求运营商确切其个人信息，并采取法律规定的保护自身权利的措施。</p>
          <p>以推介商品、工作、市场服务为目的，以及政治宣传目的，借助通讯手段直接与信息主体接触（潜在消费者），只有在事先征得个人信息主体同意的条件下才允许进行信息处理。</p>
          <p>根据个人信息主体的要求，运营商有义务立即终止机遇上述目的的个人信息处理。</p>
          <p>禁止自动处理个人信息避免产生与主体相关的法律后果，国内法律规定的情况或个人信息主体书面同意的情况除外。</p>
          <p>如果个人信息主体认为运营商处理其个人信息违反了中国的法律法规或以其他方式侵犯了其权利和自由的，则个人信息主体有权对运营商的作为或不作为向保护个人信息权力的全权机构或法院提出诉讼。</p>
          <p>个人信息主体有权保护自身权利和合法利益，包括损失赔偿和（或）精神损害赔偿。</p>
        </li>
      </ol>
    </li>

    <li class="info-about-static__content-number-ol-items" id="4">
      <span class="list-item-title">个人信息安全保障</span>
      <p>运营商通过实施合法的、计划性的和技术性的措施来保障处理的个人信息的安全，以符合中国法律法规在个人信息保护领域的要求。</p>
      <p>为防止运营商越权访问个人数据，采取以下计划性和技术性措施:</p>
      <ul>
        <li>指定人员负责组织个人信息的处理和保护;</li>
        <li>对处理个人信息的人员组成进行限定;</li>
        <li>要求人信息主体了解中国法律法规的要求和运营商有关个人信息处理与保护的规范文件;</li>
        <li>记录存储个人信息载体的流转;</li>
        <li>向个人信息主体提醒信息处理的风险;</li>
        <li>开发个人信息保护系统应对信息处理风险;</li>
        <li>检测信息保护手段的效率和性能;</li>
        <li>用户访问信息资源以及信息处理软件和硬件手段的划分;</li>
        <li>对个人信息系的用户行为进行注册与登记;</li>
        <li>使用防毒工具;</li>
        <li>在必要情况下使用防火墙、病毒检测、安全分析和加密信息保护手段;</li>
        <li>控制运营商接入个人信息，保护人信息处理技术设备地点。</li>
      </ul>
    </li>

    <li class="info-about-static__content-number-ol-items" id="5">
      <span class="list-item-title">最后条款</span>
      <p>运营商在处理个人数据方面的其他权利和义务依照中国在个人信息领域的法律法规规定。</p>
      <p>违反有关个人信息处理和保护规定的运营商员工，按照中国法律法规规定承担财物处罚、纪律处分，或行政、民事及刑事责任。</p>
    </li>
  </ol>
`

export default PrivacyZH
